import { StateCreator } from 'zustand';

export interface NOAManagerFilters {
  activeTab: 'not_yet_ready' | 'unsent' | 'sent' | 'missing';
  patientSearch: string;
  branchId: string | null;
  payerId: string | null;
  daysLeftFilter:
    | 'all'
    | 'overdue'
    | 'due_today'
    | 'due_tomorrow'
    | 'due_2_5_days';
  statusFilter: string; // 'all' or a specific status value
  errorsFilter: 'all' | 'has_errors' | 'no_errors';
}

export interface NOASlice {
  noaManagerFilters: NOAManagerFilters;
  setNOAManagerFilters: (filters: Partial<NOAManagerFilters>) => void;
}

const DEFAULT_NOA_FILTERS: NOAManagerFilters = {
  activeTab: 'not_yet_ready',
  patientSearch: '',
  branchId: null,
  payerId: null,
  daysLeftFilter: 'all',
  statusFilter: 'all',
  errorsFilter: 'all',
};

export const noaSlice: StateCreator<NOASlice> = set => ({
  noaManagerFilters: DEFAULT_NOA_FILTERS,
  setNOAManagerFilters: (filters: Partial<NOAManagerFilters>) =>
    set(state => ({
      noaManagerFilters: { ...state.noaManagerFilters, ...filters },
    })),
});
